import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'app/services/models/company.service';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { PersonService } from 'app/services/models/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-delivery-device',
  templateUrl: './create-delivery-device.component.html',
  styleUrls: ['./create-delivery-device.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateDeliveryDeviceComponent implements OnInit {
  @Input() data: { id?: number, deviceId: number, deviceName: string; companyPersonId: number, companyId: number }

  deliveryDeviceForm: FormGroup;
  deliveryDevice: any = {};
  companies: any[] = [];

  persons: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private personService: PersonService,
    private companyService: CompanyService,
    private fb: FormBuilder,
    private deliveryDeviceService: DeliveryDeviceService,
    private toastrService:ToastrService
  ) { }

  async ngOnInit() {

    this.deliveryDeviceForm = this.fb.group({
      companyId: [null, Validators.required], // Tek firma seçimi
    });
    await this.getAllCompanies();
    this.deliveryDeviceForm.patchValue({
      companyId: this.data.companyId
    });

    if (this.data.id) {
      await this.getByIdDeliveryDevice(this.data.id);
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getAllPerson(id) {
    const data = await this.personService.getAllCompaniesPersons(0, 100, id);
    console.log(data);
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  saveDeliveryDevice() {
    if (this.deliveryDeviceForm.invalid) {
      return;
    }

    const formData = {
      companyId: this.deliveryDeviceForm.value.companyId,
      deviceId: this.data.deviceId
    };

    // Backend'e gönderim işlemi yapılabilir
    this.activeModal.close(formData); // Modal'ı kapat
  }

  async getByIdDeliveryDevice(id) {
    const data = await this.deliveryDeviceService.getByIdDeliveryDevice(id);
    console.log(data);
    this.deliveryDevice = data;
  }

  async onUpdateSave() {
    
    const data = await this.deliveryDeviceService.updateDeliveryDevice({
      id:this.deliveryDevice.deliveryId,
      companyId:this.deliveryDeviceForm.value.companyId,
      deliveryCompanyPersonId:this.deliveryDevice.deliveryCompanyPersonId,
      deliveryDate : this.deliveryDevice.deliveryDate,
      deliveryId:this.deliveryDevice.deliveryId,
      deliveryMethodId:this.deliveryDevice.deliveryMethodId,
      deliveryPerson:this.deliveryDevice.deliveryPerson,
      deviceAcceptanceStatesId:this.deliveryDevice.deviceAcceptanceStatesId,
      deviceId:this.deliveryDevice.deviceId,
      isDeliveryStatus:false,
      personId:this.deliveryDevice.personId
    });
    if(data.status){
      this.deliveryDeviceService.sendEvent(true);
      this.toastrService.success(data.message);
      this.closeModal();
    }else{
      this.toastrService.error(data.message);
    }
  }
}
